import { useCallback, useEffect, useRef, useState } from 'react';

import { getAnalyticsOverview } from '../../analytics/api/analytics.api';
import type { AnalyticsSnapshot } from '../../analytics/types/analytics.types';

export function useTenantAnalytics(tenantId: number | undefined) {
  const [analytics, setAnalytics] = useState<AnalyticsSnapshot | null>(null);
  const [loading, setLoading] = useState(Boolean(tenantId));
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);
  const requestGenerationRef = useRef(0);

  const loadAnalytics = useCallback(() => {
    const generation = ++requestGenerationRef.current;
    const isCurrentRequest = () =>
      mountedRef.current && requestGenerationRef.current === generation;

    if (tenantId === undefined) {
      setAnalytics(null);
      setLoading(false);
      setError(null);
      return Promise.resolve();
    }

    setLoading(true);
    setError(null);

    return getAnalyticsOverview({ tenant_id: tenantId })
      .then((data) => {
        if (isCurrentRequest()) setAnalytics(data);
      })
      .catch(() => {
        if (isCurrentRequest()) setError('خطا در دریافت تحلیل‌های این تننت');
      })
      .finally(() => {
        if (isCurrentRequest()) setLoading(false);
      });
  }, [tenantId]);

  useEffect(() => {
    mountedRef.current = true;
    void loadAnalytics();
    return () => {
      mountedRef.current = false;
    };
  }, [loadAnalytics]);

  return { analytics, loading, error, refetch: loadAnalytics };
}
